const disableTabArrows = () => {
  // Detect IOS
  if (!navigator.userAgent.match(/(iPod|iPhone|iPad)/)) {
    return;
  }

  const handleFocus = (e) => {
    document.querySelectorAll('input, textarea').forEach((input) => {
      if (input !== e.currentTarget) {
        input.setAttribute('readonly', 'readonly');
      }
    });
  };

  const handleBlur = () => {
    document.querySelectorAll('input, textarea').forEach((input) => {
      input.removeAttribute('readonly');
    });
  };

  document.querySelectorAll('input, textarea, select, .Quantity__button').forEach((element) => {
    element.addEventListener('focus', handleFocus);
    element.addEventListener('blur', handleBlur);
  });

  // Disable tabbing to select boxes
  document.querySelectorAll('select').forEach((select) => {
    select.setAttribute('tabindex', '-1');
  });
};

export default () => {
  disableTabArrows();

  document.addEventListener('cartDidOpen', () => {
    disableTabArrows();
  });
};
